// src/config.js
// Единственное место чтения переменных окружения.
// Ключи API (login, userKey) удалены — они на сервере, не в браузере.

const config = {
    api: {
        host:    process.env.REACT_APP_API_HOST || '',
        baseUrl: `${process.env.REACT_APP_API_HOST || ''}/api`,
    },
};

if (!config.api.host) {
    console.warn('[config] Не задана переменная REACT_APP_API_HOST. Проверь .env');
}

export default config;
